<template>
  <div class="main">
    <el-form ref="form" :model="form" size="mini" label-position="top" hide-required-asterisk :disabled="$route.query.status === 'false'">
      <el-form-item prop="appraisedUser">
        <div>{{ '被评价人：' + $route.query.user }}</div>
      </el-form-item>
      <div v-for="(item, index) in formItem" :key="index">
        <el-divider content-position="left" v-if="[0,4,8,12].includes(index)">{{ item.type }}</el-divider>
        <el-form-item :prop="item.name" :rules="rules">
          <div slot="label" style="display: flex;">
            <div style="font-weight: 600;">{{ index+1+ '.' +item.text }}</div>
            <div style="padding-left: 12px;color: red;">{{ texts[form[item.name]] }}</div>
          </div>
          <el-radio-group v-model="form[item.name]">
            <el-radio :label="0">0</el-radio>
            <el-radio :label="1">1</el-radio>
            <el-radio :label="2">2</el-radio>
            <el-radio :label="3">3</el-radio>
            <el-radio :label="4">4</el-radio>
            <el-radio :label="5">5</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item style="text-align: center;" v-if="$route.query.status === 'true'">
        <el-button type="primary" size="medium" @click="onSubmit" :loading="btnLoading">提 交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
  

  <!-- 引入组件库 -->
  <script src="https://unpkg.com/element-ui/lib/index.js"></script>

  <script>

  import Vue from 'vue';
  import { Form, FormItem, Rate, Button, Input, Divider, Radio, RadioGroup } from 'element-ui';

  Vue.component(Form.name, Form);
  Vue.component(FormItem.name, FormItem);
  Vue.component(Rate.name, Rate);
  Vue.component(Button.name, Button);
  Vue.component(Input.name, Input);
  Vue.component(Divider.name, Divider);
  Vue.component(Radio.name, Radio);
  Vue.component(RadioGroup.name, RadioGroup);

  export default {
    data() {
      return {
        formItem: [
          { type: '业务力', text: '业务理解能力', name: 'v1' },
          { type: '业务力', text: '需求分析/需求管理能力', name: 'v2' },
          { type: '业务力', text: '市场调研/研究能力', name: 'v3' },
          { type: '业务力', text: '产品运营/用户运营/增长能力', name: 'v4' },
          { type: '专业力', text: '产品规划/架构/设计/开发能力', name: 'v5' },
          { type: '专业力', text: '工具能力', name: 'v6' },
          { type: '专业力', text: '项目管理能力', name: 'v7' },
          { type: '专业力', text: '度量及数据分析能力', name: 'v8' },
          { type: '内驱力', text: '主观能动性', name: 'v9' },
          { type: '内驱力', text: '情商', name: 'v10' },
          { type: '内驱力', text: '抗压能力', name: 'v11' },
          { type: '内驱力', text: '学习与提炼能力', name: 'v12' },
          { type: '协同力', text: '团队影响力/领导力', name: 'v13' },
          { type: '协同力', text: '协同协调能力', name: 'v14' },
          { type: '协同力', text: '谈判沟通能力', name: 'v15' },
          { type: '协同力', text: '快速交付/执行能力', name: 'v16' }
        ],
        rules: { required: true, message: '请点击选择评分', trigger: 'change' },
        form: {
          name: '',
          userId: ''
        },
        texts: ['完全不具备', '初步了解', '初级', '中级', '高级', '专家'],
        btnLoading: false
      }
    },
    mounted() {
      // console.log(this.$route.query)
      // const test = {"errno":1,"data":{"errcode":1,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":1,"extattr":{"attrs":[{"name":"英文名","value":"","type":1,"text":{"value":""}},{"name":"工号","value":"2017551","type":1,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":1,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":1,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
      // this.WXInfo = test.data
      this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
      this.form.name = this.WXInfo.name
      this.form.userId = this.WXInfo.userid
      this.form.appraisedUser = this.$route.query.user
      this.form.appraisedId = this.$route.query.id
      this.form.dateTime = this.$route.query.date

      this.getData()
    },
    methods: {
      async onSubmit() {
        this.btnLoading = true
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            const result = await this.postData(this.form)
            if (result.success) {
              this.$toast('提交成功')
              this.$router.push('/appraise/list?date=' + this.form.dateTime)
            } else {
              this.$toast(result.message)
            }
          } else {
            return false
          }
        })
        this.btnLoading = false
      },
      async getData() {
        const result = await this.$request({
          url: '/api/GeneralMethod/getFunctionByQuery',
          method: 'GET',
          params: {
            Model: 'appraise',
            dateTime: this.form.dateTime,
            userId: this.form.userId,
            appraisedId: this.form.appraisedId
          }
        })
        if (result.success) {
          this.form = result.data
        }
      },
      postData(data) {
        return this.$request({
          url: '/api/GeneralMethod/postFunctionSave',
          method: 'POST',
          params: { Name: 'appraise' },
          data
        })
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
    .main {
      padding: 12px;
      background-color:#FFFFFF;
    }
    /deep/.van-cell {
      background-color: #F5F5F5;
      margin: 8px 0;
      border-radius: 4px;
      padding: 16px 12px;
      font-size: 16px;
    }
  </style>
  